<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">{{addBody.id?'编辑标准':'新增标准'}}</span>
			</div>
			<el-tabs v-model="activeName" @tab-click="handleClick" v-if="addBody.id">
				<el-tab-pane label="中文" name="zh"></el-tab-pane>
				<el-tab-pane label="英文" name="en"></el-tab-pane>
				<el-tab-pane label="日语" name="jp"></el-tab-pane>
			</el-tabs>
			<el-form ref="addBody" :rules="rules" :model="addBody" label-position='top'>
				<el-form-item v-if="addBody" label="标准标题"
					:prop="activeName === 'zh' ? 'title' : activeName === 'en' ? 'title_e' : 'title_j'"
					:label-width="formLabelWidth">
					<el-input v-if="activeName === 'zh'" v-model="addBody.title" style="width: 766px;"></el-input>
					<el-input v-if="activeName === 'en'" v-model="addBody.title_e" style="width: 766px;"></el-input>
					<el-input v-if="activeName === 'jp'" v-model="addBody.title_j" style="width: 766px;"></el-input>
				</el-form-item>

				<el-form-item v-if="addBody" label="标准分类"
					:prop="activeName === 'zh' ? 'category' : activeName === 'en' ? 'category_e' : 'category_j'"
					:label-width="formLabelWidth">
					<el-select style="width: 766px;" v-model="addBody.category" v-if="activeName === 'zh'"
						placeholder="请选择标准分类">
						<el-option v-for="item in lmList" :key="item.name" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
					<el-select style="width: 766px;" v-model="addBody.category_e" v-if="activeName === 'en'"
						placeholder="请选择标准分类">
						<el-option v-for="item in lmList_e" :key="item.name" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
					<el-select style="width: 766px;" v-model="addBody.category_j" v-if="activeName === 'jp'"
						placeholder="请选择标准分类">
						<el-option v-for="item in lmList_j" :key="item.name" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item v-if="addBody" label="标准封面"
					:label-width="formLabelWidth">
					<ImageUpload v-if="activeName === 'zh'" @input="iconInput" :onloadImageList="iconList" :limit="1"
						type="image"></ImageUpload>
					<ImageUpload v-if="activeName === 'en'" @input="iconInputEn" :onloadImageList="iconListEn"
						:limit="1" type="image"></ImageUpload>
					<ImageUpload v-if="activeName === 'jp'" @input="iconInputJp" :onloadImageList="iconListJp"
						:limit="1" type="image"></ImageUpload>
				</el-form-item>

				<el-form-item v-if="addBody" label="标准描述"
					:prop="activeName === 'zh' ? 'desc' : activeName === 'en' ? 'desc_e' : 'desc_j'"
					:label-width="formLabelWidth">
					<el-input type="textarea" v-if="activeName === 'zh'" v-model="addBody.desc" style="width: 766px;"
						:rows="6"></el-input>
					<el-input type="textarea" v-if="activeName === 'en'" v-model="addBody.desc_e" style="width: 766px;"
						:rows="6"></el-input>
					<el-input type="textarea" v-if="activeName === 'jp'" v-model="addBody.desc_j" style="width: 766px;"
						:rows="6"></el-input>
				</el-form-item>

				<el-form-item v-if="addBody" label="图片"
					:label-width="formLabelWidth">
					<ImageUpload v-if="activeName === 'zh'" @input="image_url" :onloadImageList="imageList" :limit="1"
						type="image"></ImageUpload>
					<ImageUpload v-if="activeName === 'en'" @input="image_urlEn" :onloadImageList="imageListEn"
						:limit="1" type="image"></ImageUpload>
					<ImageUpload v-if="activeName === 'jp'" @input="image_urlJp" :onloadImageList="imageListJp"
						:limit="1" type="image"></ImageUpload>
				</el-form-item>

				<el-form-item v-if="addBody" label="文档上传"
					:label-width="formLabelWidth">
					<UploadFile v-if="activeName === 'zh'" @input="attachment_url" type="file" :onloadImage="attachmentList" :limit="1"
						></UploadFile>
					<UploadFile v-if="activeName === 'en'" @input="attachment_urlEn" type="file" :onloadImage="attachmentListEn"
						:limit="1" ></UploadFile>
					<UploadFile v-if="activeName === 'jp'" @input="attachment_urlJp" type="file" :onloadImage="attachmentListJp"
						:limit="1"></UploadFile>
				</el-form-item>

				<div class="dialog-footer">
					<el-button @click="goBack">取 消</el-button>
					<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
				</div>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import {
		addCStandard,
		editCStandard,
		getCStandard
	} from "@/api/content-manage"
	import ImageUpload from "@/components/ImageUpload"
		import UploadFile from "@/components/NewUploadFile"
	export default {
		components: {
			UploadFile,
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				formLabelWidth: '120px',
				addBody: {
					id: '',
					title: '',
					icon: '',
					category: '',
					category_e: '',
					category_j: '',
					desc: '',
					title_e: '',
					icon_e: '',
					desc_e: '',
					title_j: '',
					icon_j: '',
					desc_j: '',
					image_url_j: '',
					image_url_e: '',
					image_url: '',
					attachment_url_j: '',
					attachment_url_e: '',
					attachment_url: ''
				},
				attachmentList:[],
				attachmentListEn:[],
				attachmentListJp:[],
				imageList:[],
				imageListEn:[],
				imageListJp:[],
				imgList: [],
				iconList: [],
				imgListEn: [],
				iconListEn: [],
				imgListJp: [],
				iconListJp: [],
				rules: {
					title: [{
						required: true,
						message: '请输入标准标题',
						trigger: 'blur'
					}, ],
					title_e: [{
						required: true,
						message: '请输入标准标题',
						trigger: 'blur'
					}, ],
					title_j: [{
						required: true,
						message: '请输入标准标题',
						trigger: 'blur'
					}, ],
					img: [{
						required: true,
						message: '请上传标准图片',
						trigger: 'blur'
					}, ],
					img_e: [{
						required: true,
						message: '请上传标准图片',
						trigger: 'blur'
					}, ],
					img_j: [{
						required: true,
						message: '请上传标准图片',
						trigger: 'blur'
					}, ],
					icon: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					desc: [{
						required: true,
						message: '请输入标准描述',
						trigger: 'blur'
					}, ],
					icon_e: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					desc_e: [{
						required: true,
						message: '请输入标准描述',
						trigger: 'blur'
					}, ],
					icon_j: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					desc_j: [{
						required: true,
						message: '请输入标准描述',
						trigger: 'blur'
					}, ]
				},
				lmList: [{
						id: 1,
						name: '国家标准'
					},
					{
						id: 2,
						name: '行业标准'
					},
					{
						id: 3,
						name: '团体标准'
					},
				],
				lmList_e: [{
						id: 1,
						name: 'Domestic Standard'
					},
					{
						id: 2,
						name: 'Industry Standard'
					},
					{
						id: 3,
						name: 'Group Standard'
					},
				],
				lmList_j: [{
						id: 1,
						name: '国内基準'
					},
					{
						id: 2,
						name: '業界標準'
					},
					{
						id: 3,
						name: 'グループ標準'
					},
				]
			}
		},
		mounted() {
			this.addBody.id = this.$route.query.id
			if (this.addBody.id) {
				this.network().getCStandard()
			}
		},
		methods: {
			attachment_url(e) {
				this.addBody.attachment_url = JSON.stringify(e[0])
			},
			attachment_urlEn(e) {
				this.addBody.attachment_url_e = JSON.stringify(e[0])
			},
			attachment_urlJp(e) {
				this.addBody.attachment_url_j = JSON.stringify(e[0])
			},
			image_url(e) {
				this.addBody.image_url = e[0]
			},
			image_urlEn(e) {
				this.addBody.image_url_e = e[0]
			},
			image_urlJp(e) {
				this.addBody.image_url_j = e[0]
			},
			handleClick(e, a) {
				this.activeName = e.name
			},
			iconInput(e) {
				this.addBody.icon = e[0]
			},
			imgInput(e) {
				this.addBody.img = e[0]
			},
			iconInputEn(e) {
				this.addBody.icon_e = e[0]
			},
			imgInputEn(e) {
				this.addBody.img_e = e[0]
			},
			iconInputJp(e) {
				this.addBody.icon_j = e[0]
			},
			imgInputJp(e) {
				this.addBody.img_j = e[0]
			},
			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addBody.id) {
							this.network().editCStandard()
						} else {
							this.network().addCStandard()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addCStandard: async () => {
						const {
							status,
							data
						} = await addCStandard({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$message.success('新增成功')
						this.goBack()
					},
					editCStandard: async () => {
						const {
							status
						} = await editCStandard({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
						this.goBack()
					},
					getCStandard: async (uuid) => {
						const {
							data,
							status
						} = await getCStandard({
							id: this.addBody.id
						})
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.icon != null && data.result.icon) {
							this.iconList.push(data.result.icon)
						}
						if (data.result.img != null && data.result.img) {
							this.imgList.push(data.result.img)
						}
						if (data.result.icon_e != null && data.result.icon_e) {
							this.iconListEn.push(data.result.icon_e)
						}
						if (data.result.img_e != null && data.result.img_e) {
							this.imgListEn.push(data.result.img_e)
						}
						if (data.result.icon_j != null && data.result.icon_j) {
							this.iconListJp.push(data.result.icon_j)
						}
						if (data.result.img_j != null && data.result.img_j) {
							this.imgListJp.push(data.result.img_j)
						}
						if (data.result.image_url_e != null && data.result.image_url_e) {
							this.imageListEn.push(data.result.image_url_e)
						}
						if (data.result.image_url_j != null && data.result.image_url_j) {
							this.imageListJp.push(data.result.image_url_j)
						}
						if (data.result.image_url != null && data.result.image_url) {
							this.imageList.push(data.result.image_url)
						}
						if (data.result.attachment_url_j != null && data.result.attachment_url_j && data.result.attachment_url_j != '') {
							this.attachmentListJp.push(JSON.parse(data.result.attachment_url_j))
						}
						if (data.result.attachment_url_e != null && data.result.attachment_url_e && data.result.attachment_url_e != '') {
							this.attachmentListEn.push(JSON.parse(data.result.attachment_url_e))
						}
						if (data.result.attachment_url != null && data.result.attachment_url && data.result.attachment_url != '') {
							this.attachmentList.push(JSON.parse(data.result.attachment_url))
						}
					},
				}
			},
		},
	}
</script>

<style>
	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}
</style>